import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ExplorePage } from '@pages/explore/ExplorePage';
import { NotFoundPage } from '@pages/error/NotFoundPage';
import { env } from '@utils/env';

// `basename` comes from VITE_ROUTER_BASENAME so dev (/) and prod (/explorer)
// can share the same build pipeline.
const router = createBrowserRouter(
  [
    { path: '/', element: <ExplorePage /> },
    { path: '/:sceneId', element: <ExplorePage /> },
    { path: '*', element: <NotFoundPage /> },
  ],
  { basename: env.VITE_ROUTER_BASENAME },
);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
